export const DEFAULT_MAP_NAMESPACE = 'TM_IAD.PartyIdentity';
export const DEFAULT_CUSTOMER_TYPE = 'individual';
